// extracted by mini-css-extract-plugin
module.exports = {"warning":"warning_button-module--warning--iakir"};